var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp, _initialiseProps;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

import ContextFactory from "../Context";
var DEFAULT_STATE = {
  videoSrc: null,
  videoTitle: "Example title",
  videoCaption: "Video caption"
};
var VideoSettingsContext = (_temp = _class = function VideoSettingsContext(propagateMutation) {
  var _this = this;

  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _extends({}, DEFAULT_STATE);

  _classCallCheck(this, VideoSettingsContext);

  _initialiseProps.call(this);

  this.state = state;

  this._propagateMutation = function () {
    propagateMutation(_this);
  };
}, _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.setState = function (newState) {
    Object.keys(newState).map(function (key) {
      return _this2.state[key] = newState[key];
    });

    _this2._propagateMutation();
  };

  this.initializeState = function (state) {
    var selectedFrame = state.videoThumbnail ? null : 1;

    _this2.setState(_extends({}, DEFAULT_STATE, state, {
      selectedFrame: selectedFrame
    }));

    _this2.refreshThumbnailOptions();
  };

  this.refreshThumbnailOptions = function () {
    _this2.setState({
      frames: [Math.random(), 1 + Math.random(), 2 + Math.random()]
    });
  };

  this.selectFrame = function (frameTime) {
    return _this2.setState({
      selectedFrame: frameTime
    });
  };

  this.setVideoTitle = function (videoTitle) {
    return _this2.setState({
      videoTitle: videoTitle
    });
  };

  this.setVideoCaption = function (videoCaption) {
    return _this2.setState({
      videoCaption: videoCaption
    });
  };
}, _temp);

var _ContextFactory = ContextFactory(VideoSettingsContext, "VideoSettingsContext"),
    withProvider = _ContextFactory.withProvider,
    consumeContext = _ContextFactory.consumeContext;

export { withProvider, consumeContext };